import { mapActions } from "vuex";
import {
  RESET_PASSWORD, VERIFY_EMAIL
} from "@/store/actions.type.js";

export default {
  data () {
    return {
      password: null,
		resetPasswordLoading: true,
		isChangePassword : false,
	  	isVerifyEmail : false
    };
	},
	created() {
		if (this.$route.query.mode == 'verifyEmail') {
			this.isVerifyEmail = true;
			this.isChangePassword = false;
		}
		if (this.$route.query.mode == 'resetPassword') {
			this.isVerifyEmail = false;
			this.isChangePassword = true;
		}
	},

  methods: {
    ...mapActions({
		resetpasswordcall: RESET_PASSWORD,
		verifyemail : VERIFY_EMAIL
    }),

    validateresetpassword () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.resetpassword();
        }
      });
    },
    async resetpassword () {
      var self = this;
      var oobCode = this.$route.query.oobCode;
      var resetPassObj = {};
      resetPassObj.password = this.password;
      resetPassObj.oobCode = oobCode;
      this.resetPasswordLoading = true;
      self.resetpasswordcall(resetPassObj).then(success => {
        if (success) {
          this.$notify({
            group: 'allAlerts',
            title: '',
            type: 'success',
            text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-success fa fa-check-circle" aria-hidden="true"></i></span> <span class="notificationText">Password changed Successfully</span></div>'
          });

          this.$router.replace("/login/login");
        } else {
          this.$notify({
            group: 'allAlerts',
            title: '',
            type: 'error',
            text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">Password Reset Failed! </span></div>'
          });

          this.$router.replace("/login/login");
        }
      });
      this.resetPasswordLoading = false;
	  },
	async verifyEmail(){
		var oobCode = this.$route.query.oobCode;
		var verifyEmailObj = {};
		verifyEmailObj.oobCode = oobCode;
		await this.verifyemail(verifyEmailObj).then(result => {
			if (result.data.response.success) {
				this.$notify({
					group: 'allAlerts',
					title: '',
					type: 'success',
					text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-success fa fa-check-circle" aria-hidden="true"></i></span> <span class="notificationText">Email Verified  Successfully</span></div>'
				});

				this.$router.replace("/home/");
			}
			else {
				this.$notify({
					group: 'allAlerts',
					title: '',
					type: 'error',
					text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">Email Verification Failed! </span></div>'
				  });
			}
		})
	}
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/psiverify.js